import styled from 'styled-components'

export const Style = styled.div`
  margin-top: 140;
  margin-bottom: 160;
  .card-image-box {
    padding: 60px 15px;
    img {
      width: 202px;
      height: 202px;
    }
    .text {
      .title {
        margin-top: 40px;
      }
    }
  }
  .title-three {
    margin-top: 20px;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    margin-top: 20px;
    background: linear-gradient(to bottom, rgba(243, 223, 250, 0), #f3dffa);
    .card-image-box {
      padding: 0;
      box-shadow: none;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      img.card-image {
        margin: 0 !important;
        width: 90px !important;
        height: 85px !important;
        padding: 0 0px 0 10px !important;
      }
      .text {
        padding: 0;
        width: calc(100% - 110px);
      }
      .title {
        padding: 0;
        margin: 0;
        margin-top: 0 !important;
      }
    }
  }
  .text-body-one {
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.61;
    letter-spacing: normal;
    color: #888888;
  }
  .title-three {
    margin-top: 15px;
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #333333;
    margin-bottom: 15px;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .column-margin-bottom {
    margin-bottom: 24px;
  }
  .border-text-wrap {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
`
